export default __webpack_public_path__ + "static/media/logo_railjet.4341ec32.svg";